import baseAPI from "../api/baseApi";
import { authHeader } from "../helpers/authHeader";

const getAnalyisStatesReport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);

    const res =
      data.userType == "2"
        ? await baseAPI.post(`/analytics-statistics-merchant`, formdata, {
            headers: authHeader(),
          })
        : await baseAPI.post(`/analytics-statistics-branch`, formdata, {
            headers: authHeader(),
          });
    return res;
  } catch (error) {
    console.log(error);
  }
};

const AnalysisService = {
  getAnalyisStatesReport,
};

export default AnalysisService;
